// extracted by mini-css-extract-plugin
export default {"paddingTop":"privacypolicy_paddingTop__L-AIN","button":"privacypolicy_button__7J2NQ"};